import { Alert, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { QUICKBOOK_DETAILS_FIELDS } from "./bookAllFields";
import FormField from "../../../../components/common/FormField";
import {
  addBooking,
  getBlinkDetails,
  getQuickBookDetails,
  initialBookingState,
  setAddBookingResponse,
} from "../../../../store/reducers/quickBookSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Notification from "../../../../components/common/notification/Notification";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import ManageQuickBook from "./ManageQuickBook";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ManageSelectFinancial from "./ManageSelectFinancial";
import ManageFinancialForm from "../Financial/ManageFinancialForm";
import FinancialDetailPage from "../Financial/FinancialDetailPage";
import BlinkDetails from "./BlinkDetails";
const QuickBookLog = () => {
  const [formData, setFormData] = useState<any>(initialBookingState);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const { isBookingAdded, singleBooking } = useSelector(
    (state: any) => state?.quickBook
  );
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: any) => state?.user);
  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [id]: value,
    }));
  };
  const [open, setOpen] = useState(false);
  const [selectedFinancialModel, setSelectedFinancial] = useState(false);
  const [value, setValue] = React.useState("0");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getQuickBookDetails());
    dispatch(getBlinkDetails());
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  }, []);

  const handleSubmit = () => {
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      dispatch(addBooking(formData));
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  useEffect(() => {
    if (isBookingAdded) {
       dispatch(getQuickBookDetails());
      dispatch(setAddBookingResponse(false));
      setFormData(initialBookingState);
      setOpen(false);
      setSelectedFinancial(false);
      dispatch(setNotificationAction({ message: [], severity: "error" }));
    }
  }, [isBookingAdded]);

  const handleOpen = () => {
    setOpen(true);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };
  const handleSelectedModel = () => {
    setSelectedFinancial(true);
    setOpen(false);
  };

  return (
    <>
      {selectedFinancialModel && (
        <ManageSelectFinancial
          open={selectedFinancialModel}
          onHide={() => setSelectedFinancial(false)}
          title={"Financial"}
        />
      )}
      {open && (
        <ManageQuickBook
          open={open}
          onHide={() => setOpen(false)}
          title={singleBooking?.clientId ? "Edit Financial" : "Add Financial"}
          selectData={singleBooking}
        />
      )}
      {/* <Tabs

        variant="scrollable"
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        sx={{
          borderRight: 1,
          marginRight: "10px",
          borderColor: "divider",
          minWidth: "250px",
          backgroundColor: "#fafafa",
          "& .MuiTab-root": {
            alignItems: "flex-start",
            justifyContent: "flex-start",
            textTransform: "none",
            fontSize: "15px",
            fontWeight: 600,
            color: "#333",
          },
          "& .Mui-selected": {
            color: "#1d997d",
            backgroundColor: "#d4f9dc",
          },
        }}
      >
        <Tab value="0" label="Accountancy Package" />
        <Tab value="1" label="Financial" />
      </Tabs> */}
      {/* {value === "0" && ( */}
      <div style={{ marginTop: "20px" }}>
        <PageTitle
          title="Accountancy Package"
          button={singleBooking?.clientId ? "Edit" : "Add"}
          onClick={singleBooking?.clientId ? handleOpen : handleSelectedModel}
        />
        <Grid
          container
          spacing={2}
          sx={{
            padding: "10px",
            mt: 1,
            background: "#E5F4F1",
            borderRadius: "5px",
            border: "1px solid #CFCFCF",
          }}
        >
          <Grid
            item
            md={12}
            xs={12}
            sx={{ paddingLeft: "0px !important", paddingRight: "16px" }}
          >
            <Notification />
            <Grid container spacing={0.5}>
              <Grid item md={12} xs={12} sx={{ mb: 2 }}>
                <Typography variant="h5" sx={{ fontWeight: "600" }}>
                  {userProfile?.AccountingSoftware
                    ? userProfile?.AccountingSoftware
                    : ""}{" "}
                  Details
                </Typography>
              </Grid>
              {QUICKBOOK_DETAILS_FIELDS &&
                QUICKBOOK_DETAILS_FIELDS.map((field) => (
                  <FormField
                    key={field.id}
                    // onPaste={(e) => e.preventDefault()}

                    {...{
                      ...field,
                      value: singleBooking ? singleBooking[field.id] || "" : "",
                      variant: "outlined",
                      isNonMarginTop: true,
                      inSingleGridForm: true,
                      onChange: onChangeAction,
                      disabled: true,
                      maxLength: 250,
                      blurFilter: (field?.id ==='clientId' || field?.id ==='clientSecret') ? true : false,
                      InputProps: {
                        sx:
                          field?.type === "text" || field?.type === "password"
                            ? { height: "30px" }
                            : {
                                padding: "6px 12px",
                                // height: "36px",
                              },
                              // 👇 BLUR TEXT
                      },
                    }}
                  />
                ))}
              <Alert severity="info" sx={{ mt: 2 }}>
                <ul style={{ margin: 0, paddingLeft: "1.5rem" }}>
                  <li>
                    <strong>Per-Customer:</strong> Removal invoices post against
                    matched/created QBO customers (no duplicates when email/name
                    matches).
                  </li>
                  <li>
                    <strong>Single ‘Removal’ Customer:</strong> All removal
                    invoices post under the chosen single QBO customer; no new
                    removal customers are created in QBO.
                  </li>
                </ul>
              </Alert>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <BlinkDetails/>
      {/* )}
      {value === "1" && ( */}
        <div style={{ marginTop: "20px" }}>
          <FinancialDetailPage />
        </div>
      {/* )} */}
    </>
  );
};
export default QuickBookLog;
